/**
 * Возвращает цвет текста в зависимости от состояния элемента.
 *
 * @param {boolean} isActive - Является ли элемент активным.
 * @param {boolean} isHovered - Наведен ли курсор на элемент.
 * @param {boolean} isMouseDown - Находится ли элемент в состоянии нажатия (mousedown).
 * @returns {string} CSS-переменная цвета текста для текущего состояния.
 */
export const getTextFillColor = (
  isActive: boolean,
  isHovered: boolean,
  isMouseDown: boolean
): string => {
  if (!isActive && isHovered && isMouseDown) return 'var(--mui-palette-widgetTabs-colorPressed)';
  if (!isActive && isHovered) return 'var(--mui-palette-widgetTabs-colorHover)';
  if (isActive) return 'var(--mui-palette-statistics-periodActiveText)';
  return 'var(--mui-palette-widgetTabs-colorDefault)';
};
